import { SUPPORT_EMAIL } from "src/utils/constants";

export default function RetryPopup({
  open,
  errorMessage,
  onClose,
}) {


  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      {/* Modal */}
      <div className="w-full max-w-md rounded-xl bg-white shadow-xl animate-fadeIn">
        {/* Header */}
        <div className="flex items-center justify-between border-b px-5 py-4">
          <h2 className="text-[24px] font-semibold text-gray-800">
            Login Failed
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-xl"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="px-5 py-4">
          <p className="text  text-red-700 font-semibold bg-red-600 bg-opacity-5 flex gap-2 items-center p-3 rounded">
            <span>
                
           <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32"><path fill="currentColor" d="M16 2C8.3 2 2 8.3 2 16s6.3 14 14 14s14-6.3 14-14S23.7 2 16 2m-1.1 6h2.2v11h-2.2zM16 25c-.8 0-1.5-.7-1.5-1.5S15.2 22 16 22s1.5.7 1.5 1.5S16.8 25 16 25"/></svg>
            </span>
            {errorMessage ||
              "We couldn’t log you in. Please try again or raise a complaint."}
          </p>
            <p className="text-sm text-gray-600 ">
            Please raise a dispute by emailing us at <a href={`mailto:${SUPPORT_EMAIL}`} className="text-red-600 hover:text-red-800">{SUPPORT_EMAIL} </a>
 with a brief description of your problem.
          </p>
          
        </div>
        

        {/* Footer */}
        <div className="flex gap-3 border-t px-5 py-4">
          

          <button
            onClick={onClose}
            className="flex-1 rounded-lg bg-[#CB2B2C] px-4 py-2 text-sm font-medium text-white hover:bg-red-700"
          >
                Retry Login
          </button>
        </div>
      </div>
    </div>
  );
}